import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/9_1.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Cymes"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p24,
            }}
            content={
                <div>
                    <ul>
                        <li>Poproszę cymes!</li>
                        <li>Bardzo dobry wybór! – uśmiecha się Łukaszewski. – Suszone owoce z cynamonem i cukrem – niby tak niewiele, a jakie dobre! Macie deser na mój koszt!
                        Kiedy karczmarz odchodzi, Emil dodaje:</li>
                        <li>Mówią, że klient nasz pan. Dlatego Łukaszewski ma prawie wszystko na słodko, według żydowskich przepisów.</li>
                        <li>Witam serdecznie śliwkowego króla – przechodzący brodacz z pejsami wyciąga rękę, żeby przyjacielsko poklepać Emila po plecach, ale powstrzymuje ją, jak gdyby uznał, że nie jest z nim w wystarczająco zażyłych stosunkach. – Słyszałem, że pan Emil się dogadał na geszeft z Lejmerem? Może byście i mnie dowieźli, na weselnym stole śliwek nigdy za wiele, wiecie, syn mi się żeni… – tutaj brodacz zawahał się, patrząc na ciebie.</li>
                        <li>Panie Garfunkel, zajedziemy jutro z samego rana! – odpowiada Emil, po czym dodaje: – Ale sam bym sadu nie obrobił… Niech Pan pozna kogoś, kto mi w tym pomógł!</li>
                        <li>A, skoro to osoba zaufana… – teraz brodacz odwraca się w twoją stronę bez skrępowania.</li>
                        <li>Feliks Garfunkel, miło mi – przedstawia się, po czym wraca do omawiania szczegółów transakcji z Emilem. Po chwili macha wam na pożegnanie i wraca do swojego stołu, a wy zabieracie się do właśnie podanego deseru.</li>
                    </ul>
                </div>
            }
        />

    );
}